import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { useSite, siteImg } from "../context/SiteContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
  const site = useSite();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || loading) return;
    setLoading(true);
    try {
      const r = await axios.post(`${API}/subscribe`, { email: email.trim() });
      if (r.data.status === "already_subscribed") {
        toast("Tu es déjà dans le cercle ✦");
      } else {
        toast.success("Bienvenue dans l'univers Akalibe ✦");
      }
      setEmail("");
    } catch (err) {
      toast.error("Adresse e-mail invalide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" data-testid="newsletter-section" className="relative py-24 md:py-32 lg:py-40 overflow-hidden">
      <div className="absolute inset-0 -z-10">
        {site?.images?.newsletter ? (
          <img src={siteImg(site, "newsletter", null)} alt="" className="w-full h-full object-cover opacity-20" />
        ) : (
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(212,175,55,0.18),transparent_60%)]" />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-base via-base/85 to-base" />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto px-6 text-center"
      >
        <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gold">Le cercle</span>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 leading-tight">
          Sois au monde <span className="gold-text">avant tout le monde</span>.
        </h2>
        <p className="text-[#A3A3A3] font-light mt-6 max-w-xl mx-auto">
          Sorties, coulisses, dates. Reçois l'univers Akalibe en avant-première, directement.
        </p>

        <form onSubmit={submit} data-testid="newsletter-form" className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto mt-10">
          <input
            data-testid="newsletter-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="ton@email.com"
            className="flex-1 bg-black/50 border border-white/[0.12] px-5 py-4 text-sm text-white placeholder:text-[#8A8A8A] focus:outline-none focus:border-gold/50 transition-colors"
          />
          <button
            data-testid="newsletter-submit-btn"
            disabled={loading}
            className="bg-gold text-black font-medium px-8 py-4 hover:bg-gold-light transition-colors disabled:opacity-50 text-sm tracking-wide"
          >
            {loading ? "…" : "Rejoindre"}
          </button>
        </form>
      </motion.div>
    </section>
  );
};
